import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { reaction, toJS } from "mobx";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { Button, Input, Utils } from "arv-reactcomponents";

import  Analytics, { GTM } from "../../analytics";
import Event from "../../analytics/eventFactory";

import StoreBrandAutocomplete from "./StoreBrandAutocomplete";
import {
  isStringInArray,
  validatePincode,
  setLastUsedPincode,
} from "../../utils";
import { PINCODE_LENGTH } from "npmlinks-constants";

const brandJournerId = process.env.REACT_APP_STORELOCATORBRANDID;
@withRouter
@inject("StoreListStore", "StoreLocatorStore", "CommonStore")
@observer
class StoreLocatorForm extends Component {
  static windowLocation() {
    const { search } = window.location;
    return search;
  }

  constructor(props) {
    super(props);
    this.state = {
      pincodeValue: "",
      brandError: "",
      dontShowAutoComplete: !!brandJournerId,
    };
    this.removePopStateListener = Utils.noop;
    this.pinCodeChange = this.pinCodeChange.bind(this);
    this.brandChange = this.brandChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.resetSLForm = this.resetSLForm.bind(this);
    // this.verifyBrand = this.verifyBrand.bind(this);
    this.clearBrand = this.clearBrand.bind(this);
    this.clearPincode = this.clearPincode.bind(this);
    this.watchForPincodeChange = this.watchForPincodeChange.bind(this);
  }

  componentDidMount() {
    this.watchForPincodeChange();
    if (brandJournerId) {
      this.setState({ dontShowAutoComplete: true }, () => {
        this.props.StoreListStore.setBrand(brandJournerId);
      });
    } else {
      this.props.StoreLocatorStore.fetchBrands().then(response => {
        const brands = toJS(response);
        if (brands.length === 1) {
          this.props.StoreListStore.setBrand(brands[0]);
          this.setState({ dontShowAutoComplete: true });
        }
      });
    }

    // this.setPicodeValue();
    this.initiateStoreLocator();
  }

  componentWillUnmount() {
    this.removePopStateListener();
  }
  watchForPincodeChange() {
    reaction(
      () => this.props.StoreListStore.currentPincode,
      value => {
        const newVal = value;
        const search = StoreLocatorForm.windowLocation();
        const params = new URLSearchParams(search);
        const pincodeValue = params.get("pc");
        if (this.state.pincodeValue !== newVal && !pincodeValue) {
          this.setState({ pincodeValue: newVal });
          // setLastUsedPincode(newVal);
        }
      },
    );
  }

  onFormSubmit(e) {
    if (e) {
      e.preventDefault();
    }
    const { brandName } = this.props.StoreListStore;
    const { isBrandPage } = this.props.CommonStore;
    if (isBrandPage && !brandName) {
      this.setState({
        brandError: "Please select a brand from list",
      });
      document.getElementById("nw-sl-brnadinputbox").focus();
      Analytics.trackEvent({
        action: Event.action.FIND_NOW_ERROR,
        category: Event.category.STORE_LOCATOR,
        label: "no_brand",
      });
    } else if (
      !this.state.pincodeValue ||
      this.state.pincodeValue.length < PINCODE_LENGTH
    ) {
      this.pincodeElem.focus();
      const errorMsg = `Please enter ${PINCODE_LENGTH} digits`;
      this.props.StoreListStore.setPincodeError(errorMsg);
      Analytics.trackEvent({
        action: Event.action.FIND_NOW_ERROR,
        category: Event.category.STORE_LOCATOR,
        label: "no_pincode",
      });
    } else {
      setLastUsedPincode(this.state.pincodeValue);
      const { pincodeValue } = this.state;
      const { brandName } = this.props.StoreListStore;
      Analytics.trackEvent({
        action: Event.action.BRAND_SELECTION,
        category: Event.category.STORE_LOCATOR,
        label: brandName,
      });
      Analytics.trackEvent({
        action: Event.action.PINCODE_FILL,
        category: Event.category.STORE_LOCATOR,
        label: pincodeValue,
      });
      GTM.pushWithEvent(
        {
          brand: brandName,
          pincode: pincodeValue,
        },
        Event.GTMEvent.STORE_LOCATOR_SEARCH,
      );
      this.props.StoreListStore.fetchStores(brandName, pincodeValue); // this sets the brand
      const queryString = `?br=${brandName}&pc=${pincodeValue}`;
      if (e) {
        Analytics.trackEvent({
          action: Event.action.FIND_NOW_CLICK_SL,
          category: Event.category.STORE_LOCATOR,
        });
      }
      this.setQueryParams(queryString);
    }
  }

  get brandPageName() {
    return this.props.CommonStore.isBrandPage || this.state.dontShowAutoComplete
      ? "nwc-hide"
      : "";
  }

  get isBrandSelected() {
    return !this.props.StoreListStore.brandName ? "nwc-hide" : "";
  }

  get isPincodeEntered() {
    return !this.state.pincodeValue ? "nwc-hide" : "";
  }

  get isFormNotValid() {
    const { isBrandPage } = this.props.CommonStore;
    const { pincodeValue } = this.state;
    const { brandName } = this.props.StoreListStore;
    return !!(
      (
      isBrandPage && 
      (!pincodeValue ||
      !brandName ||
      validatePincode(pincodeValue))
      ) || !pincodeValue || validatePincode(pincodeValue)
    );
  }

  // setPicodeValue() {
  //   this.setState({
  //     pincodeValue: getlastUsedPincode(),
  //   });
  // }

  setQueryParams(queryString) {
    this.props.history.push(queryString);
  }

  setupStoreLocatorOnUrl() {
    const { isDesktop } = this.props.CommonStore;
    if (window.location.pathname.indexOf("store-locator") > -1) {
      const search = StoreLocatorForm.windowLocation();
      const params = new URLSearchParams(search);
      let brandName = params.get("br");
      const pincodeValue = params.get("pc");
      let pincodeError = pincodeValue && validatePincode(pincodeValue);
      if (
        pincodeValue &&
        (pincodeValue.length < PINCODE_LENGTH || pincodeError)
      ) {
        if (pincodeValue) {
          pincodeError = "";
        }
      }
      if (search && brandName && pincodeValue && !pincodeError) {
        this.setState({
          pincodeValue,
        });
        const states = {
          showStoreLoader: true,
          showNoStoreImage: false,
          showStoreList: false,
          showForm: isDesktop,
          showMap: true,
          storePlaceholderImage: false,
        };
        this.props.StoreListStore.setStates(states);
        this.props.StoreListStore.setBrand(brandName);
        setTimeout(() => {
          this.onFormSubmit();
        }, 1000);
      } else {
        brandName =
          (this.props.CommonStore.brandDetails &&
            this.props.CommonStore.brandDetails.parentBrandName &&
            this.props.CommonStore.brandDetails.parentBrandName[0]) ||
          "";
        // this.props.StoreListStore.setBrand(brandName);
        this.setState({
          pincodeValue,
        });
        this.props.StoreListStore.resetStoreLocatorPage(brandName);
      }
    }
  }

  handleBrowserBack() {
    const onPopState = () => {
      this.setupStoreLocatorOnUrl();
    };
    window.addEventListener("popstate", onPopState);
    this.removePopStateListener = () => {
      window.removeEventListener("popstate", onPopState);
    };
  }

  initiateStoreLocator() {
    this.handleBrowserBack();
    this.setupStoreLocatorOnUrl();
  }

  pinCodeChange(e) {
    const invalidMsg = validatePincode(e.target.value);
    this.resetSLForm();
    if (invalidMsg) {
      this.props.StoreListStore.setPincodeError(invalidMsg);
    }
    this.setState({
      pincodeValue: e.target.value,
    });
  }

  brandChange(brand) {
    this.setState({
      brandError: "",
    });
    this.props.StoreListStore.setBrand(brand);
    const validBrand = isStringInArray(
      brand,
      this.props.StoreLocatorStore.brandsList,
    );
    if (validBrand) {
      this.setState({
        brandError: "",
      });
      this.props.StoreListStore.setBrand(validBrand);
    } else {
      this.setState({
        brandError: "Please select a brand from list",
      });
    }
  }

  resetSLForm() {
    this.props.StoreListStore.setPincodeError();
  }

  // verifyBrand() {
  //   if (!this.state.brandName) {
  //     this.setState({
  //       brandError: "Please select a brand from list",
  //     });
  //   }
  // }

  clearBrand() {
    this.setState({
      brandError: "",
    });
    this.props.StoreListStore.setBrand("");
  }

  clearPincode() {
    this.resetSLForm();
    this.setState({
      pincodeValue: "",
    });
    this.pincodeElem.focus();
  }

  render() {
    const errorMsg = this.props.StoreListStore.notAValidPincode;
    const { brandError } = this.state;
    const { brandName } = this.props.StoreListStore;
    return (
      <form
        id="nwc-store-locator-form"
        className={`nw-storelocatorform ${this.props.className}`}
        onSubmit={e => this.onFormSubmit(e)}
        noValidate
      >
        <fieldset>
          <legend className="nwc-slform-legend">Locate Store</legend>
          <div
            className={`nwc-storelocator-form-fields nw-sl-brandinput ${
              this.brandPageName
            }`}
          >
            {/* i want to <strong>shop</strong> the */}
            <Button
              className={`nwc-btn nwc-close nwc-clear-input ${
                this.isBrandSelected
              }`}
              onClick={() => this.clearBrand()}
              onKeyPress={() => this.clearBrand()}
              type="button"
            />
            <StoreBrandAutocomplete.component
              brand={brandName}
              onBrandSelection={this.brandChange}
              // onBlur={this.verifyBrand}
            />
            <span className="nwc-sl-from-error">{brandError}</span>
          </div>
          <div className="nwc-storelocator-form-fields">
            {/* <strong>stores</strong> near */}
            <Button
              className={`nwc-btn nwc-close nwc-clear-input ${
                this.isPincodeEntered
              }`}
              onClick={() => this.clearPincode()}
              onKeyPress={() => this.clearPincode()}
              type="button"
            />
            <Input
              id="nw-sl-pidcodeinputbox"
              className="nwc-inp-dash nwc-inp-sm  nw-storelocatorform-input"
              placeholder="Enter Your Pincode"
              value={this.state.pincodeValue}
              onChange={this.pinCodeChange}
              maxLength={`${PINCODE_LENGTH}`}
              required
              minLength={`${PINCODE_LENGTH}`}
              onFocus={this.resetSLForm}
              pattern="\d*"
              inputRef={element => {
                this.pincodeElem = element;
              }}
            />
            <span className="nwc-sl-from-error">{errorMsg}</span>
          </div>
        </fieldset>
        <Button
          className="nwc-btn-primary nwc-btn-normal nw-storelocatorform-btn"
          type="submit"
          disabled={this.isFormNotValid}
        >
          FIND NOW
        </Button>
      </form>
    );
  }
}

StoreLocatorForm.wrappedComponent.defaultProps = {
  class: "",
};

StoreLocatorForm.wrappedComponent.propTypes = {
  class: PropTypes.string,
  StoreListStore: PropTypes.shape({
    currentPincode: PropTypes.string.isRequired,
    fetchStores: PropTypes.func.isRequired,
    notAValidPincode: PropTypes.string.isRequired,
    setPincodeError: PropTypes.func.isRequired,
    setBrand: PropTypes.func.isRequired,
    brandName: PropTypes.string,
    setStates: PropTypes.func.isRequired,
    resetStoreLocatorPage: PropTypes.func.isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    brandDetails: PropTypes.object,
    isBrandPage: PropTypes.bool.isRequired,
    changeBrandName: PropTypes.func.isRequired,
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
  StoreLocatorStore: PropTypes.shape({
    brandsList: PropTypes.object,
    fetchBrands: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export { default as StoreBrandAutocomplete } from "./StoreBrandAutocomplete";

const getFinalComponent = component =>
  inject("StoreListStore", "StoreLocatorStore", "CommonStore")(
    observer(component),
  );

const ProjectComponent = {
  getFinalComponent,
  wrapper: StoreLocatorForm.wrappedComponent,
  component: StoreLocatorForm,
};

export default ProjectComponent;
